import { finiteOrNull, plural } from "./format";

// Guest-capacity rule; BE-1 mirrors it (plan.md "Room capacity").

// A missing limit becomes Infinity, so it never binds.
const limit = (v) => finiteOrNull(v) ?? Infinity;

const roomCapacity = (roomtype) => {
    const adults = limit(roomtype?.max_adults);
    const children = limit(roomtype?.max_children);
    const occupancy = limit(roomtype?.max_occupancy);
    return {
        adults: Math.min(adults, occupancy),
        children: Math.max(0, Math.min(children, occupancy - 1)),
        guests: Math.min(occupancy, adults + children),
    };
};

// stays: [{ roomtype, rooms }]
export const bookingCapacity = (stays) =>
    stays.reduce(
        (total, { roomtype, rooms }) => {
            if (!(rooms > 0)) return total;
            const room = roomCapacity(roomtype);
            return {
                rooms: total.rooms + rooms,
                maxAdults: total.maxAdults + room.adults * rooms,
                maxChildren: total.maxChildren + room.children * rooms,
                maxGuests: total.maxGuests + room.guests * rooms,
            };
        },
        { rooms: 0, maxAdults: 0, maxChildren: 0, maxGuests: 0 }
    );

// Field-keyed messages; the guests limit is reported on adults.
export const capacityProblems = (adults, children, capacity) => {
    const problems = {};
    const { rooms, maxAdults, maxChildren, maxGuests } = capacity;
    if (adults < rooms)
        problems.adults = `At least 1 adult per room: ${plural(rooms, "room needs", "rooms need")} ${plural(rooms, "adult")}.`;
    else if (adults > maxAdults) problems.adults = `These rooms hold at most ${plural(maxAdults, "adult")}.`;
    else if (adults + children > maxGuests) problems.adults = `These rooms hold at most ${plural(maxGuests, "guest")}.`;
    if (children > maxChildren) problems.children = `These rooms hold at most ${plural(maxChildren, "child", "children")}.`;
    return problems;
};
